import { render, staticRenderFns } from "./EpsCard.vue?vue&type=template&id=81c5ef44&scoped=true"
import script from "./EpsCard.js?vue&type=script&lang=js&external"
export * from "./EpsCard.js?vue&type=script&lang=js&external"
import style0 from "./EpsCard.scss?vue&type=style&index=0&id=81c5ef44&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c5ef44",
  null
  
)

export default component.exports